import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import AddedValuesList from "../../../common/AddedValuesList";
import "./education.scss";
import {
  fetchAddExpEducationData,
  fetchAdvancedEducationOptions,
  fetchDeleteEducation,
  fetchDentalMedicalOptions,
  fetchExpEducationList,
  fetchOtherGraduteOptions,
  fetchProviderEduType,
  fetchRemoveLicenseItem,
  fetchSearchQuery,
  fetchUnderGraduateOptions,
  fetchUpdateEducationList,
} from "../../../store/ProviderInfo/ProviderEducationActions";
import { addProviderExpEdu } from "../../../store/ProviderInfo/ProviderEducationReducer";
import dangerIcon from "../../../assets/Icons/ic-alert-red.svg";
import { useLocation } from "react-router-dom";

const educationTypeNameMap = {
  undergraduate: "Undergraduate Degree",
  dental: "Dental/Medical Degree",
  graduate: "Other Graduate/Post Graduate Degree",
  advance: "Advanced Education/Training",
};

const ProviderEducation = ({
  providerId,
  onlyPopup = false,
  closePopupCallback = () => {},
  openEducationPopup,
}) => {
  const [educationValues, setEducationValues] = useState([]);
  const [missingData, setMissingData] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [popupState, setPopupState] = useState("");
  const [editingData, setEditingData] = useState();
  const [degreeDropdownOptions, setDegreeDropdownOptions] = useState([]);
  const [enableDegreeField, setEnableDegreeField] = useState(false);
  const [enableInstitutionField, setEnableInstitutionField] = useState(false);
  const [enableYearField, setEnableYearField] = useState(false);
  const [enableAddButton, setEnableAddButton] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [remountFormCreator, setRemountFormCreator] = useState(0);

  const [showError, setShowError] = useState(false);
  const location = useLocation();
  const locationData = location.pathname.split("/");
  const [prvId, setPrvId] = useState(providerId ? providerId : locationData[2]);

  const dispatch = useDispatch();

  const { isEduLoading, expEduData, eduDeleteError, eduError, eduErrorMsg } =
    useSelector((state) => state.providerExperienceEducation);

  const { isEduTypeLoading, eduTypeData } = useSelector(
    (state) => state.providerEduType
  );
  const { otherEduOptions } = useSelector(
    (state) => state.providerOtherEduOption
  );
  const { advancedData } = useSelector(
    (state) => state.providerAdvancedEduOption
  );
  const { underGraduateData } = useSelector(
    (state) => state.providerUnderGraduateEduOption
  );
  const { dentalMedicalData } = useSelector(
    (state) => state.providerDentalMedicalEduOption
  );
  const { isInstituteSearchData } = useSelector(
    (state) => state.providerEduInstitutionSearch
  );

  useEffect(() => {
    if (providerId) {
      setPrvId(providerId);
    } else {
      setPrvId(locationData[2]);
    }
  }, [providerId]);

  useEffect(() => {
    if (eduError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [eduError]);

  useEffect(() => {
    setOpenPopup(openEducationPopup);
  }, [openEducationPopup]);

  useEffect(() => {
    if (prvId) {
      dispatch(fetchExpEducationList(prvId));
      dispatch(fetchProviderEduType());
      dispatch(fetchOtherGraduteOptions());
      dispatch(fetchAdvancedEducationOptions());
      dispatch(fetchUnderGraduateOptions());
      dispatch(fetchDentalMedicalOptions());
    }
  }, [prvId, refreshTrigger]);

  useEffect(() => {
    if (expEduData) {
      const addedValues = [...expEduData];
      setEducationValues(addedValues);
      handleMissingData();
    }
  }, [expEduData]);

  useEffect(() => {
    handleMissingData();
  }, [educationValues]);

  useEffect(() => {
    if (
      popupState === "edit" &&
      editingData &&
      eduTypeData &&
      eduTypeData.length > 0
    ) {
      const degreeTypeValue = getDegreeType(editingData?.degreeCategory);

      setFormValues({
        degreeCategory: degreeTypeValue,
        degreeType: `${editingData?.degreeType?.name} - ${editingData?.degreeType?.description}`,
        institutionRaw: editingData?.institutionRaw?.name,
        year: editingData?.year,
      });
    } else if (popupState !== "edit") {
      setFormValues({});
    }
  }, [editingData, popupState, eduTypeData]);

  ///////// event Handlers /////////

  const handleMissingData = () => {
    const hasMissingData = expEduData?.some(
      (item) => !item.year || item.year === ""
    );
    setMissingData(hasMissingData);
  };

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = async (deleteId) => {
    const updatedspecialities = educationValues.filter(
      (educationItem) => educationItem.displayId !== deleteId
    );
    await dispatch(
      fetchDeleteEducation({
        providerId: prvId,
        displayId: deleteId,
      })
    );
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [deleteId]: false,
    }));
    await dispatch(fetchExpEducationList(prvId));
    setEducationValues(updatedspecialities);
  };

  const getDegreeType = (val) => {
    if (!val || !eduTypeData || eduTypeData.length === 0) return "";

    let dataFound = "";
    eduTypeData.map((newItem) => {
      if (newItem?.metadata?.name === val) {
        dataFound = newItem.metadata.name;
      } else if (
        newItem?.metadata?.type === val ||
        newItem?.metadata?.type.includes(val)
      ) {
        dataFound = newItem.metadata.name;
      }
    });
    if (!dataFound && (val.includes("Degree") || val.includes("Training"))) {
      dataFound = val;
    }

    return dataFound;
  };

  const handleUpdateDegreeDropdownOption = (degreeItem) => {
    if (degreeItem == "Undergraduate Degree" || degreeItem == "undergraduate") {
      setDegreeDropdownOptions(underGraduateData);
    } else if (
      degreeItem == "Dental/Medical Degree" ||
      degreeItem === "dental"
    ) {
      setDegreeDropdownOptions(dentalMedicalData);
    } else if (
      degreeItem == "Other Graduate/Post Graduate Degree" ||
      degreeItem == "graduate"
    ) {
      setDegreeDropdownOptions(otherEduOptions);
    } else if (
      degreeItem == "Advanced Education/Training" ||
      degreeItem == "advanced"
    ) {
      setDegreeDropdownOptions(advancedData);
    }
  };

  ///////////////////// RENDER FUNCTIONS ////////////////////

  const RenderFormCreatorForAddEducation = () => {
    if (isEduLoading) return null;
    if (popupState === "edit" && editingData?.degreeCategory) {
      handleUpdateDegreeDropdownOption(editingData.degreeCategory);
    }

    const educationSchema = [
      {
        component: "dropdown",
        label: "TYPE",
        name: "degreeCategory",
        defaultDropdownPlaceHolder: "Select a degree type",
        value: popupState === "edit" ? formValues.degreeCategory : "",
        defaultValue: popupState === "edit" ? formValues.degreeCategory : "",
        dropdownOptions: eduTypeData,
        Placeholder: "Select a degree type",
        onSelectCallBack: (res, data) => {
          handleUpdateDegreeDropdownOption(data);
          if (data && data !== "") {
            setEnableDegreeField(true);
          } else {
            setEnableDegreeField(false);
            setEnableInstitutionField(false);
            setEnableYearField(false);
          }
        },
        required: false,
        dropdownPlaceHolder: "Select a degree type",
      },
      {
        component: "dropdown",
        label: "DEGREE",
        name: "degreeType",
        dropdownPlaceHolder: "Select a degree",
        value: popupState === "edit" ? formValues.degreeType : "",
        defaultValue: popupState === "edit" ? formValues.degreeType : "",
        dropdownOptions: degreeDropdownOptions,
        enable: ["name", "description"],
        Placeholder: "Select a degree",
        disabled: popupState === "add" ? !enableDegreeField : false,
        onSelectCallBack: (res, data) => {
          if (data && data !== "") {
            setEnableInstitutionField(true);
          } else {
            setEnableInstitutionField(false);
            setEnableYearField(false);
          }
        },
        required: false,
      },
      {
        component: "autoComplete",
        id: "institutionRaw",
        label: "INSTITUTION",
        type: "text",
        name: "institutionRaw",
        key:
          popupState === "edit"
            ? `institution-${editingData?.displayId}`
            : "institution-add",
        autoCompletePlaceHolders: "Enter Institution",
        required: false,
        value: popupState === "edit" ? formValues.institutionRaw : "",
        defaultValue: popupState === "edit" ? formValues.institutionRaw : "",
        suggestions: isInstituteSearchData && isInstituteSearchData,
        renderAddedValues: false,
        isMultiple: false,
        noErrorInAutoComplate: true,
        isEdit: popupState === "edit",
        resetValue: false,
        disabled: popupState === "add" ? !enableInstitutionField : false,
        onValueChangeCallback: (res) => {
          dispatch(fetchSearchQuery(res));
          if (res && res.trim() !== "") {
            setEnableYearField(true);
            setEnableAddButton(true);
          } else {
            setEnableYearField(false);
            setEnableAddButton(false);
          }
        },
        validationErrorText: "Institution name is required.",
      },
      {
        component: "input",
        type: "text",
        label: "YEAR",
        name: "year",
        value: popupState === "edit" ? formValues.year : "",
        defaultValue: popupState === "edit" ? formValues.year : "",
        valueChangeCallback: () => {},
        required: false,
        disabled: popupState === "add" ? !enableYearField : false,
      },
    ];

    const extractDegreeType = (degreeType) => {
      const [name, ...descriptionParts] = degreeType.split(" - ");
      return {
        name: name.trim(),
        description: descriptionParts.join(" - ").trim() || "",
      };
    };

    const mapDegreeCategory = (degreeCategory) => {
      const lowerCaseCategory = degreeCategory.toLowerCase();

      if (lowerCaseCategory.includes("undergraduate")) return "undergraduate";
      if (lowerCaseCategory.includes("dental")) return "dental";
      if (lowerCaseCategory.includes("advance")) return "advance";

      return "graduate";
    };

    const transformData = (input) => {
      // console.log(input);

      const uniqueId = Date.now().toString(20);
      return {
        displayId: uniqueId,
        degreeType: extractDegreeType(input.degreeType),
        degreeCategory: mapDegreeCategory(input.degreeCategory),
        institutionRaw: {
          displayId: uniqueId,
          name: input.institutionRaw.trim(),
        },
        year: input.year,
      };
    };

    const handleClose = () => {
      dispatch(fetchExpEducationList(prvId));
      setPopupState("");
      setOpenPopup(!openPopup);
      closePopupCallback("success");
    };

    return (
      <div className="form-without-border-style">
        <CgFormCreator
          key={editingData?.displayId || remountFormCreator}
          schema={educationSchema}
          primaryButton={popupState === "edit" ? "Save" : "ADD"}
          noCancel={popupState === "edit" ? false : true}
          enablePrimaryBtn={enableAddButton}
          resetValuesOnSubmit={false}
          onSubmitCallback={(val) => {
            if (popupState !== "edit") {
              const updatedValues = [...educationValues];
              const convertedData = transformData(val);
              updatedValues.push(convertedData);
              setEducationValues(updatedValues);
              setEnableAddButton(false);
              setEnableDegreeField(false);
              setEnableInstitutionField(false);
              setEnableYearField(false);
              setRemountFormCreator((prev) => prev + 1);
            } else {
              const data = {
                degreeCategory: val.degreeCategory
                  ? val.degreeCategory
                  : editingData?.degreeCategory,
                degreeTypeName: val.degreeType.split("-")[0].trim()
                  ? val.degreeType.split("-")[0].trim()
                  : editingData?.degreeType?.name,
                ...(val.year && { year: val.year }),
                newInstitutionRawName: val?.institutionRaw
                  ? val?.institutionRaw
                  : editingData?.institutionRaw?.name,
                institutionDisplay: val?.institutionRaw
                  ? val?.institutionRaw
                  : editingData?.institutionRaw?.name,
                isActive: true,
              };
              dispatch(
                fetchUpdateEducationList({
                  payload: data,
                  providerId: prvId,
                  displayId: editingData.displayId,
                })
              ).then(() => {
                setEducationValues([]);
                setFormValues({});
                setEditingData(null);
                setDegreeDropdownOptions([]);
                setEnableDegreeField(false);
                setEnableInstitutionField(false);
                setEnableYearField(false);
                setEnableAddButton(false);
                setOpenPopup(false);
                setPopupState("");
                setRefreshTrigger((prev) => prev + 1);
                closePopupCallback("success");
              });
            }
          }}
          onCancel={() => {
            /** Updating states same as clicking on cross icon */
            setOpenPopup(false);
            setPopupState("");
            setFormValues({});
            setEditingData(null);
            setDegreeDropdownOptions([]);
            setEnableDegreeField(false);
            setEnableInstitutionField(false);
            setEnableYearField(false);
            setEnableAddButton(false);
            closePopupCallback();
          }}
        />
        {popupState !== "edit" && (
          <AddedValuesList
            key={educationValues}
            onClose={() => {
              setOpenPopup(false);
              setEducationValues(expEduData);
              closePopupCallback();
            }}
            onSave={async (res) => {
              const resIds = res.map((item) => item.id);
              const displayIds = expEduData.map((item) => item.displayId);

              const newItems = res.filter(
                (item) => !displayIds.includes(item.id)
              );
              for (const item of newItems) {
                const data = {
                  degreeCategory: item?.metadata?.degreeCategory,
                  degreeTypeName: item?.metadata?.degreeType?.name,
                  year: item?.metadata?.year,
                  newInstitutionRawName: item?.metadata?.institutionRaw?.name,
                  institutionDisplay: item?.metadata?.institutionRaw?.name,
                  isActive: true,
                };
                await dispatch(
                  fetchAddExpEducationData({ providerId: prvId, data })
                );
              }
              const removedItems = expEduData.filter(
                (item) => !resIds.includes(item.displayId)
              );
              for (const item of removedItems) {
                await dispatch(
                  fetchRemoveLicenseItem({
                    providerId: prvId,
                    licenseId: item.displayId,
                  })
                );
              }
              handleClose();
            }}
            enableSave
            addedValuesHeading="Your Education"
            primaryButton="SAVE"
            secondaryButton="CANCEL"
            addedValuesList={educationValues?.map((item) => {
              return {
                name: `${item.institutionRaw.name}, ${item.degreeType.name} - ${item.year}`,
                id: item.displayId,
                metadata: item,
              };
            })}
          />
        )}
      </div>
    );
  };

  const RenderEducationPopupModal = () => {
    if (!openPopup) {
      return null;
    }
    return (
      <PopupModal
        customRender={RenderFormCreatorForAddEducation}
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
          setPopupState("");
          setEnableAddButton(false);
          setFormValues({});
          setEditingData(null);
          setDegreeDropdownOptions([]);
          setEnableDegreeField(false);
          setEnableInstitutionField(false);
          setEnableYearField(false);
          setEnableAddButton(false);
          closePopupCallback();
        }}
        onSave={async () => {
          if (popupState !== "edit") {
            await dispatch(addProviderExpEdu(educationValues));
            await dispatch(fetchExpEducationList(prvId));
            setOpenPopup(!openPopup);
            closePopupCallback("success");
          }
        }}
        popupHeading={"Education"}
      />
    );
  };

  const RenderEducationList = () => {
    if (isEduTypeLoading) return null;
    if (isEduLoading) return <div> Loading ... </div>;
    if (eduError) return null;
    return (
      <div>
        <h3 className="section-header top-thirty overview">
          Education {educationValues?.length > 0 && (
            <span className="edu-count">({educationValues?.length})</span>
          )}
          <a
            className="btn edit-button"
            onClick={() => {
              setOpenPopup(!openPopup);
              setPopupState("add");
              setFormValues({});
              setEditingData(null);
              setDegreeDropdownOptions([]);
              setEnableDegreeField(false);
              setEnableInstitutionField(false);
              setEnableYearField(false);
              setEnableAddButton(false);
            }}
          >
            +Add
          </a>
        </h3>
        {missingData && (
          <div className="missing-data-info">
            <div>
              <img
                className="missing-data-img"
                src={dangerIcon}
                alt="Missing Info Image"
              />
            </div>
            <div className="missing-data">
              <p> MISSING DATA</p>
            </div>
          </div>
        )}
        <div className="specialitiesDataCard">
          {!isEduLoading && eduDeleteError && (
            <div className="alert alert-danger" role="alert">
              {eduDeleteError}
            </div>
          )}
          {expEduData?.length > 0 ? (
            expEduData?.map((item, index) => {
              return (
                <div className="row specialityCardRow" key={index}>
                  <div className="col-12 border specialityRowHeight">
                    {!confirmDeleteMap[item.displayId] && (
                      <>
                        <button
                          type="button"
                          className="btn border-0 editspeciality"
                          onClick={() => {
                            setOpenPopup(!openPopup);
                            setPopupState("edit");
                            setEnableAddButton(true);
                            setEditingData(item);
                            handleUpdateDegreeDropdownOption(
                              item?.degreeCategory
                            );
                          }}
                        >
                          EDIT
                        </button>
                        |
                      </>
                    )}
                    {confirmDeleteMap[item.displayId] && (
                      <button
                        type="button"
                        className="btn border-0 canceldelete"
                        onClick={() =>
                          toggleConfirmDelete(item.displayId, false)
                        }
                      >
                        CANCEL
                      </button>
                    )}
                    <button
                      type="button"
                      className={`btn deleteBtn ${
                        confirmDeleteMap[item.displayId]
                          ? "deleteConfirmation"
                          : "border-0"
                      }`}
                      onClick={() => {
                        if (confirmDeleteMap[item.displayId]) {
                          deleteAPiCall(item.displayId);
                        } else {
                          toggleConfirmDelete(item.displayId, true);
                        }
                      }}
                    >
                      {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                    </button>
                  </div>
                  <table className="education-table">
                    <tr>
                      <td style={{ width: "10%" }}>
                        <div className="table-content info-list-degree">
                          <h3 className="headerValue">
                            {item.degreeType.name}
                          </h3>
                        </div>
                      </td>
                      <td style={{ width: "25%" }}>
                        <div className="table-content">
                          <p className="header">School</p>
                          <p className="headerValue">
                            {item.institutionRaw.name}
                          </p>
                        </div>
                      </td>
                      <td style={{ width: "25%" }}>
                        <div className="table-content">
                          <p className="header">Degree Type</p>
                          <p className="headerValue">
                            {educationTypeNameMap?.[item?.degreeCategory] ??
                              item?.degreeCategory}
                          </p>
                        </div>
                      </td>
                      <td style={{ width: "40%" }}>
                        <div className="table-content">
                          <p
                            className={`header ${
                              !item.year ? "error-label" : ""
                            }`}
                          >
                            Year Graduated
                          </p>
                          {item.year ? (
                            <p className="headerValue">{item.year}</p>
                          ) : (
                            <a
                              className="update-info-link"
                              onClick={() => {
                                setOpenPopup(!openPopup);
                                setPopupState("edit");
                                setEnableAddButton(true);
                                setEditingData(item);
                                handleUpdateDegreeDropdownOption(
                                  item?.degreeCategory
                                );
                                setEnableDegreeField(true);
                                setEnableInstitutionField(true);
                                setEnableYearField(true);
                              }}
                            >
                              Add Year
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              );
            })
          ) : (
            <div>
              <div className="info-section ng-isolate-scope">
                <p className="empty-module ng-binding">
                  No education data for this provider
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const RenderEducationErrors = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        {eduErrorMsg}
      </div>
    );
  };

  return (
    <div className="education provider-education-wrapper">
      <div>
        {!onlyPopup && RenderEducationList()}
        {RenderEducationPopupModal()}
        {RenderEducationErrors()}
      </div>
    </div>
  );
};

export default ProviderEducation;
